import React from 'react';
import styled, { css } from 'styled-components';

const baseHeading = css`
  color: ${({
    theme: {
      colors: { brand },
    },
  }) => brand};
  font-family: ${({
    theme: {
      fonts: { heading },
    },
  }) => heading};
`;

const H1 = styled.h1`
  ${baseHeading}
  font-size: ${({
    theme: {
      fontSizes: { heading1 },
    },
  }) => heading1}
`;

const H2 = styled.h2`
  ${baseHeading}
font-size: ${({
  theme: {
    fontSizes: { heading2 },
  },
}) => heading2}

`;

const H3 = styled.h3`
  ${baseHeading}
font-size: ${({
  theme: {
    fontSizes: { heading3 },
  },
}) => heading3}
`;

const H4 = styled.h4`
  ${baseHeading}
font-size: ${({
  theme: {
    fontSizes: { heading4 },
  },
}) => heading4}

`;

const H5 = styled.h5`
  ${baseHeading}
font-size: ${({
  theme: {
    fontSizes: { heading5 },
  },
}) => heading5}

`;

const H6 = styled.h6`
  ${baseHeading}
font-size: ${({
  theme: {
    fontSizes: { heading6 },
  },
}) => heading6}

`;

const headings = {
  1: ({ children, ...props }) => <H1 {...props}>{children}</H1>,
  2: ({ children, ...props }) => <H2 {...props}>{children}</H2>,
  3: ({ children, ...props }) => <H3 {...props}>{children}</H3>,
  4: ({ children, ...props }) => <H4 {...props}>{children}</H4>,
  5: ({ children, ...props }) => <H5 {...props}>{children}</H5>,
  6: ({ children, ...props }) => <H6 {...props}>{children}</H6>,
};

export default function Heading({ level, children, ...props }) {
  const HeadingEl = headings[level] || headings[2];

  return <HeadingEl {...props}>{children}</HeadingEl>;
}
